export const iconFontAwesomeFilesFolder = (
	<i className="fa-solid fa-folder"></i>
);
